export default "__VITE_ASSET__cd97d5da__"